<template>
  <div class="OperateContractItem mt_5" v-if="ready">
    <div class="OperateContractItem__mc">
      <div class="OperateContractItem__mc__title">
        <div></div>
        <div>#</div>
        <div>商品名稱</div>
        <div>商品<br />代號</div>
        <div>繳費<br />年期</div>
        <div class="justify-content-end text-right">保額/計畫別</div>
        <div class="justify-content-end text-right">應繳保費</div>
        <div class="justify-content-end">增值回饋金<br />給付方式</div>
      </div>

      <template v-for="(MC, index) in contractData.mc_prod_list">
        <!-- 主約 -->
        <div class="OperateContractItem__mc__info" :key="'mc_' + index">
          <div
            class="checkbox checkbox-inline mr_0"
            v-if="selectedMode == 'checkbox'"
          >
            <input
              type="checkbox"
              name="OperateContractItem"
              :id="`OperateContractItem_${MC.mc_idx}`"
              :checked="MC.is_checked"
              @change="updateChecked"
              v-model="MC.is_checked"
            />
            <label :for="`OperateContractItem_${MC.mc_idx}`"></label>
          </div>
          <div>{{ index + 1 }}</div>
          <div class="justify-content-start text-left">
            {{ MC.prod_name
            }}<template v-if="MC.job_cat != ''">{{
              `(職業類別:${MC.job_cat}類)`
            }}</template>
          </div>
          <div>{{ MC.prod_id }}</div>
          <div>
            {{ MC.pay_prd_show }}{{ MC.pay_prd_show != "" ? "年" : "" }}
          </div>
          <div class="justify-content-end">
            {{ formatMethods(MC.amt) }}{{ MC.amt != "" ? MC.amt_unit_nm : "" }}
          </div>
          <div class="justify-content-end">
            {{ formatMethods(MC.premium)
            }}{{ MC.premium != "" ? MC.curr_nm : "" }}
          </div>
          <div class="justify-content-end">
            {{ MC.add_method_nm }}
          </div>
        </div>
        <!-- 附約 -->
        <div
          class="OperateContractItem__mc__SC"
          v-for="SC in MC.sc_prod_list"
          :key="'sc_' + MC.mc_idx + '_' + SC.sc_idx"
        >
          <div></div>
          <div class="justify-content-start text-left">
            └ {{ SC.prod_name
            }}<template v-if="SC.job_cat != ''">{{
              `(職業類別:${SC.job_cat}類)`
            }}</template>
          </div>
          <div>{{ SC.prod_id }}</div>
          <div>{{ SC.pay_prd }}{{ SC.pay_prd != "" ? "年" : "" }}</div>
          <div class="justify-content-end">
            {{ formatMethods(SC.amt) }}{{ SC.amt != "" ? SC.amt_unit_nm : "" }}
          </div>
          <div class="justify-content-end">
            {{ formatMethods(SC.premium)
            }}{{ SC.premium != "" ? SC.curr_nm : "" }}
          </div>
        </div>
        <!-- 應繳保費合計(折減前) -->
        <div
          class="OperateContractItem__totalDiscount"
          :class="{
            final: !MC.has_disc,
          }"
          :key="'total_' + MC.mc_idx"
        >
          <div>
            {{ getPay_freq_nm(MC.pay_freq).split("繳")[0] }}應繳保費(保費折減前)
            合計:
          </div>
          <div>
            {{ formatMethods(getTotal_mc(MC))
            }}{{ MC.premium != "" ? MC.curr_nm : "" }}
          </div>
        </div>
        <div
          class="OperateContractItem__totalDiscount final"
          :key="'disc_total_' + MC.mc_idx"
          v-if="MC.has_disc"
        >
          <div>
            {{ MC.pay_freq_nm.split("繳")[0] }}應繳保費(保費折減後) 合計:
          </div>
          <div>{{ formatMethods(MC.total_disc_premium) }}{{ MC.curr_nm }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import Avatar from "@/desktop/components/Avatar";
import moment from "moment";
export default {
  mixins: [mf_Mixin],
  props: ["contractData", "selected", "NO", "selectedMode"],
  components: { Avatar },
  data() {
    return {
      detailData: null,
      ready: false,
    };
  },
  created() {
    this.init();
  },
  computed: {},
  methods: {
    moment,
    getTotal_mc(mc) {
      let total = parseInt(mc.premium);
      if (mc.sc_prod_list) {
        mc.sc_prod_list.forEach((item) => (total += parseInt(item.premium)));
      }
      return total;
    },

    init() {
      this.$mfAPI
        .MFB0_1150__getPremiumScheduleData({
          proposalMap: {
            ...this.contractData,
            agent_id: this.$store.state.userInfo.id,
            prod_idx: this.contractData.prod_idx,
          },
        })
        .then((res) => {
          this.detailData = res.prod_list;
          this.contractData.mc_prod_list.forEach((item, index, array) => {
            let obj = this.detailData[index];
            if (obj) {
              item.is_checked = true;
              item.add_method_nm = "";
              if (item.add_method) {
                let paragrpno = this.$paragrpno.add_method.find((method) => {
                  return item.add_method.indexOf(method.paraval) > -1;
                });
                if (paragrpno.paradetlno) {
                  item.add_method_nm = paragrpno.paradetlno;
                }
              }
              let mc_obj = obj.mc_prod_list[0];
              if (!item.amt_unit_nm) {
                item.amt_unit_nm = mc_obj.amt_unit_nm;
              }
              item.pay_prd_show = mc_obj.pay_prd; //後端已處理特殊繳費年期判斷
              array[index] = { ...this.detailData[index], ...item };
              let sc_prod_list = item.sc_prod_list;
              let detailData_sc_prod_list = obj.sc_prod_list;
              if (sc_prod_list && detailData_sc_prod_list) {
                sc_prod_list.forEach((sc_item, index) => {
                  let detailData_sc_prod = detailData_sc_prod_list[index];
                  if (detailData_sc_prod) {
                    sc_item.curr_nm = detailData_sc_prod.curr_nm;
                  }
                });
              }
            }
          });
          this.$emit("isReady");
          this.ready = true;
          this.$forceUpdate();
          setTimeout(() => {
            this.registerHanlink();
          }, 50);
        });
    },
    updateChecked() {
      //更新選取狀態
      this.$emit("updateMCProdList", this.contractData.mc_prod_list);
    },
  },
};
</script>

<style lang="scss" scoped>
.OperateContractItem {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 2px #53c480;
  &__head {
    background-color: #cceed9;
    border-bottom: solid 2px #53c480;
    padding: 4px 15px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    &__date,
    &__insured {
      white-space: nowrap;
      flex-grow: 0;
    }
  }
  &__mc {
    &__index {
      padding: 15px;
      line-height: 1.38;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
      //olor: #027a39;
      background-color: #e5f6ec;
      //border-top: solid 1px rgba(194, 196, 199, 0.8);
    }
    &__title {
      width: 100%;
      display: flex;
      font-weight: 700;
      //color: #027a39;
      background-color: #e5f6ec;
      //border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        //border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 3px 7px;
      }

      & > div:nth-of-type(1) {
        width: 6%;
      }
      & > div:nth-of-type(2) {
        width: 4%;
      }
      & > div:nth-of-type(3) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(4) {
        width: 6%;
      }
      & > div:nth-of-type(5) {
        width: 6%;
      }
      & > div:nth-of-type(6) {
        width: 14%;
      }
      & > div:nth-of-type(7) {
        width: 14%;
      }
      & > div:nth-of-type(8) {
        width: 12%;
      }
    }
    //主約
    &__info {
      width: 100%;
      display: flex;
      color: #323a45;
      background-color: #fff;
      // border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        // border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        width: 6%;
        &.checkbox input + label:before {
          margin-left: 50%;
        }
      }
      & > div:nth-of-type(2) {
        width: 4%;
      }
      & > div:nth-of-type(3) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(4) {
        width: 6%;
      }
      & > div:nth-of-type(5) {
        width: 6%;
      }
      & > div:nth-of-type(6) {
        width: 14%;
      }
      & > div:nth-of-type(7) {
        width: 14%;
      }
      & > div:nth-of-type(8) {
        width: 12%;
      }
    }
    //   附約
    &__SC {
      width: 100%;
      display: flex;
      color: #323a45;
      //background-color: #f5f5f5;
      //border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        //border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        width: 10%;
      }
      & > div:nth-of-type(2) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(3) {
        width: 6%;
      }
      & > div:nth-of-type(4) {
        width: 6%;
      }
      & > div:nth-of-type(5) {
        width: 14%;
      }
      & > div:nth-of-type(6) {
        width: 14%;
      }
      & > div:nth-of-type(7) {
        width: 12%;
      }
    }
  }

  //   應繳保費合計(折減前)
  &__totalDiscount {
    padding: 10px;
    line-height: 1.38;
    display: flex;
    justify-content: Flex-end;
    align-items: center;
    font-weight: 700;
    border: solid 1px rgba(194, 196, 199, 0.8);
    &.final {
      color: #03c;
      background-color: #fff3c2;
    }
  }
}
</style>
